import React from 'react';

import { faMoneyBillWave } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

export default {
  title: 'Zones fiscales',
  name: 'fiscalite_zones',
  icon: faMoneyBillWave,
  resource: 'fiscalite_zones',
  primaryKey: 'idzone',
  sort: 'ordre',
  query: { delete: 0 },
  head: {
    etiquette: 'Étiquette',
    plafond: 'Plafond',
    plafond_pls: 'Plafond PLS',
  },
  list: ({ values }) => [values.etiquette, values.plafond, values.plafond_pls],
  edit: ({ values, props }) => [
    <TextField {...props} fullWidth name='plafond' label='Plafond' value={values.plafond} />,
    <TextField {...props} fullWidth name='plafond_pls' label='Plafond PLS' value={values.plafond_pls} />,
  ],
  popup: true,
};
